export const isDevEnv = () =>
  ['development', 'test', 'feqa-1', 'feqa-2', 'demo', 'stage', 'at1'].includes(
    import.meta.env.VITE_ENV,
  );

export const isTestEnv = () => import.meta.env.VITE_ENV === 'test';
export const isStageEnv = () => import.meta.env.VITE_ENV === 'stage';
export const isProdEnv = () => import.meta.env.VITE_ENV === 'production';

export const isTestOrStageEnv = () => isTestEnv() || isStageEnv();
export const isStageOrProdEnv = () => isStageEnv() || isProdEnv();
